import { HttpHeaders } from '@capacitor/core';

// Header names are case-insensitive; native platforms preserve original casing.
export const getHeaderValue = (
  headers: HttpHeaders,
  name: string
): string | undefined => {
  if (!headers) {
    return undefined;
  }

  const target = name.toLowerCase();
  const matchedKey = Object.keys(headers).find(
    (key) => key.toLowerCase() === target
  );

  return matchedKey === undefined ? undefined : headers[matchedKey];
};
